
    <svg viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="60" cy="60" r="60" fill="#FAFAFA" />
      <path
        d="M40.6589 29.5815C44.0329 23.7375 51.5055 21.7352 57.3495 25.1092C63.1935 28.4832 65.1958 35.9559 61.8218 41.7999L51.8027 59.1535L30.6398 46.935L40.6589 29.5815Z"
        fill="#9CC992"
      />
      <path
        d="M42.2723 75.6605C38.8983 81.5045 31.4256 83.5068 25.5816 80.1328C19.7377 76.7588 17.7354 69.2861 21.1094 63.4421L31.1285 46.0886L52.2914 58.307L42.2723 75.6605Z"
        fill="#1A5358"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M78.4567 94.8825C68.0767 94.8825 59.9355 85.3378 62.3959 74.5392C63.7528 68.5895 68.5923 63.7495 74.5625 62.3963C85.3858 59.938 94.9878 68.0573 94.9878 78.4184C94.9878 87.521 87.5884 94.8825 78.4567 94.8825Z"
        fill="#D5CCC4"
      />
      <path
        d="M84.0142 69.3072L69.3071 84.0143L72.9839 87.6911L87.691 72.984L84.0142 69.3072Z"
        fill="white"
      />
      <circle cx="86.9991" cy="38.183" r="8.01519" fill="#F3B87D" />
    </svg>
  